import React, { useContext } from 'react';
import { isMobileOnly } from 'react-device-detect';

import './Orientation.scss';
import landscapeAnimation from '../../assets/images/rotate_device.gif';
import useMobileOrientation from '../../hooks/useMobileOrientation';
import AppModeContext from '../AppMode/AppMode.context';

interface OrientationProps {
  children: React.ReactNode
}

export default function Orientation({ children }: OrientationProps) {
  const { isLandscape } = useMobileOrientation();
  const { RETAIL_MODE, TRADING_MODE } = useContext(AppModeContext);

  return (
    <>
      {
        isMobileOnly && isLandscape && !RETAIL_MODE && !TRADING_MODE
          ? <img className="orientation-img" src={ landscapeAnimation } alt="change to portrait" />
          : (
            <>
              { children }
            </>
          )
      }
    </>
  );
}
